/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Signal_Rates_MetaInputs */

const en_landing_signal_rates_meta = /** @type {(inputs: Landing_Signal_Rates_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rates • 8 clients matched • Medium conviction`)
};

/**
* | output |
* | --- |
* | "Rates • 8 clients matched • Medium conviction" |
*
* @param {Landing_Signal_Rates_MetaInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_signal_rates_meta = /** @type {((inputs?: Landing_Signal_Rates_MetaInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Signal_Rates_MetaInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_signal_rates_meta(inputs)
});